import {appConfig} from "@/config/app.conf";
export const cartoHelpers = {
    fromApiToMapPoints,
    setProperties,
    calcularDistancia,
};


    function _fromApiToPointFeature(elemento) {

        const geoPoint = {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        elemento.coordenadas[1],
                        elemento.coordenadas[0]
                    ]
                },
                "properties": setProperties(elemento)
            };

        return geoPoint
    }

    function setProperties(elemento) {
        
        return {
            "id":           parseInt(elemento.id),
            "name":         elemento.name,
            "url":          elemento.url || '',
            "motor":        parseInt(elemento.idMotor) || 1,
            "guardado":     elemento.season || [],
            "parkings":     elemento.parkings || [],
            "refugios":     elemento.refugios || [],
            "fechas" :      elemento.refugeAvailability || [],
            "imagen" :      `${appConfig.resources}img/mountainhuts/${elemento.friendlyUrl}/refuge-card-img.png`,
            "friendly":     elemento.friendlyUrl,
            "limiteDias":   elemento.totalMaxBookingDays,
            "personas":     elemento.maxBookingPlaces,
            "xsalto":       elemento.xsaltoRefugeId
        }

    }

    function fromApiToMapPoints(elements) {
        const featureCollection = {
            type: 'FeatureCollection',
            features: []
        };

        elements.forEach( item => {
            if(parseFloat(item.coordenadas[0]) !== 0)
                featureCollection.features.push(_fromApiToPointFeature(item))
        })

        return featureCollection;
    }

    function calcularDistancia(lat1, lon1, lat2, lon2) {
        const R = 6371; // Radio de la tierra en Km
        const dLat = _toRad(lat2-lat1);
        const dLon = _toRad(lon2-lon1);
        const _lat1 = _toRad(lat1);
        const _lat2 = _toRad(lat2);

        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(_lat1) * Math.cos(_lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        const d = R * c;
        return d;
    }

    function _toRad(value) {
        return value * Math.PI / 180;
    }